import { combineReducers } from "redux";
import inspections from "./inspections";
import vehicles from "./vehicles";
import config from "./config";
import vehicleTypes from "./vehicles/vehicleTypes";
import Customers from "../reducers/customers/customers";
import listVehicle from "../reducers/vehicles/listVehicle";
import listInspection from "../reducers/vehicles/listInspection";
import CustomersInspection from "../reducers/customers/customerInspection";
import InspectorInspection from "../reducers/inspector/inspection";
import adminCustomer from "./admin";
const appReducer = combineReducers({
  inspections: inspections,
  vehicles: vehicles,
  config: config,
  vehicleTypes,
  Customers: Customers,
  CustomersInspection,
  listVehicle,
  listInspection,
  InspectorInspection,
  adminCustomer
});
const reducer = (state, action) => {
  if (action.type === "USER_LOGOUT") {
    state = undefined;
  }

  return appReducer(state, action);
};
export default reducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js